import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState
} from 'react';
//import { BigNumber } from 'ethers';
import { SignMessage } from './SignMessage';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { SectionDivider } from './SectionDivider';
import { Row, Col, Form, Button, ProgressBar } from 'react-bootstrap'

/*
//CFX Contract TEST
import ERC20GameTokenArtifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import ERC20GameTokenAddress from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//BUSD_TEST
import BUSD_Artifact from '../artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import BUSD_Address from '../artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//CFALPHA TEST
import CFALPHA_Artifact from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';
*/

//CFX Contract TEST
import ERC20GameTokenArtifact from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import ERC20GameTokenAddress from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//CFALPHA LIVE
import CFALPHA_Artifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';



const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;

export function ERC20GameTokenADMINApp(): ReactElement {
  return (
    <StyledAppDiv>
      <ERC20GameTokenADMINContract />
    </StyledAppDiv>
  );
}

export function ERC20GameTokenADMINContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [erc20GameTokenContract, setErc20GameTokenContract] = useState<Contract>();
  const [erc20GameTokenContractAddr, setErc20GameTokenContractAddr] = useState<string>('');
  const [transferAmountInput, setTransferAmountInput] = useState<string>('');

  const [erc20GameTokenName, setTokenName] = useState<string>('');
  const [erc20GameTokenSymbol, setTokenSymbol] = useState<string>('');
  const [erc20GameTokenOwner, setTokenOwner] = useState<string>('');
  const [erc20GameTokenTotalSupply, setTokenTotalSupply] = useState(0);

  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }
    setSigner(library.getSigner());
    
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

  function handleAttachContract() {

   //is a signer is defined
    if (!signer) {
      return;
    }

    async function attachErc20GameTokenContract(signer: Signer): Promise<void> {

      const ERC20GameToken = new ethers.ContractFactory(
        ERC20GameTokenArtifact.abi,
        ERC20GameTokenArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const erc20GameTokenContract = await ERC20GameToken.deploy('Cosmic Force','CFX');
        //await erc20GameTokenContract.deployed();

        const erc20GameTokenContract = await ERC20GameToken.attach(ERC20GameTokenAddress.address);

        const tokenName = await erc20GameTokenContract.name();
        const tokenSymbol = await erc20GameTokenContract.symbol();
        const tokenOwner = await erc20GameTokenContract.owner();
        const tokenTotalSupply = await erc20GameTokenContract.totalSupply();

        setErc20GameTokenContract(erc20GameTokenContract);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);

        const totalSupply = Number(ethers.utils.formatUnits(tokenTotalSupply,18));
    
        setTokenTotalSupply(totalSupply);

       // window.alert(`ERC20GameToken deployed to: ${erc20GameTokenContract.address}`);

        setErc20GameTokenContractAddr(erc20GameTokenContract.address);
        
      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachErc20GameTokenContract(signer);
  }

  
  function handleTransferAmountChange(event: ChangeEvent<HTMLInputElement>): void {
    event.preventDefault();
    setTransferAmountInput(event.target.value);
  }

  function handleTransferSubmit(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    if (!erc20GameTokenContract) {
      return;
    }

    if (!transferAmountInput) {
      window.alert('Amount cannot be empty');
      return;
    }

    async function submitTransfer(erc20GameTokenContract: Contract): Promise<void> {
      try {

        window.alert(ethers.utils.parseEther(transferAmountInput));

        const setTxn = await erc20GameTokenContract.withdraw(transferAmountInput);

        await setTxn.wait();

        window.alert(`Withdraw Success!`);

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    submitTransfer(erc20GameTokenContract);
  }
  
  return (
    <>
      <StyledGreetingDiv>
        <StyledLabel>Contract addr</StyledLabel>
        <div>
          {erc20GameTokenContractAddr ? (
            erc20GameTokenContractAddr
          ) : (
            <em>{`<Contract not yet deployed>`}</em>
          )}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Owner</StyledLabel>
        <div>
          {erc20GameTokenOwner}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Name</StyledLabel>
        <div>
          {erc20GameTokenName}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <StyledLabel>Symbol</StyledLabel>
        <div>
          {erc20GameTokenSymbol}
        </div>
        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
                <div></div>
        <StyledLabel>Total Supply</StyledLabel>
        <div>
          {erc20GameTokenTotalSupply}
        </div>

        {/* empty placeholder div below to provide empty first row, 3rd col div for a 2x3 grid */}
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <StyledLabel htmlFor="transferInput">Withdraw BUSD To Admin</StyledLabel>
        <StyledInput
          id="transferAmountInput"
          type="text"
          placeholder={transferAmountInput ? '' : '<Amount>'}
          onChange={handleTransferAmountChange}
          style={{ fontStyle: transferAmountInput ? 'normal' : 'italic' }}
        ></StyledInput>
        <StyledButton
          disabled={!active || !erc20GameTokenContract ? true : false}
          style={{
            cursor: !active || !erc20GameTokenContract ? 'not-allowed' : 'pointer',
            borderColor: !active || !erc20GameTokenContract ? 'unset' : 'blue'
          }}
          onClick={handleTransferSubmit}
        >
          Submit Withdraw
        </StyledButton>

      </StyledGreetingDiv>
    </>
  );
}
